import * as SelectPrimitive from '@radix-ui/react-select';
import { type ComponentPropsWithoutRef, type ElementRef, forwardRef } from 'react';

import { cn } from '../../lib/utils';

const SelectItem = forwardRef<
  ElementRef<typeof SelectPrimitive.Item>,
  ComponentPropsWithoutRef<typeof SelectPrimitive.Item>
>(({ className, children, ...props }, ref) => (
  <SelectPrimitive.Item
    ref={ref}
    className={cn(
      'rds-select-item',
      `
          r:relative r:flex r:w-full r:p-2.5 r:cursor-pointer r:select-none
          r:rounded-xs r:text-base r:outline-hidden
          r:focus:bg-(--item-bg-selected)
          r:focus:text-(--item-text-selected)
          r:data-[disabled]:pointer-events-none
          r:data-[disabled]:opacity-50
        `,
      className
    )}
    data-sds-id="select-item"
    {...props}
  >
    <SelectPrimitive.ItemText>{children}</SelectPrimitive.ItemText>
  </SelectPrimitive.Item>
));
SelectItem.displayName = SelectPrimitive.Item.displayName;

export { SelectItem };
